/**
 * Created by netre on 25.06.2017.
 */
import i18n from 'i18next';
import XHR from 'i18next-xhr-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import moment from 'moment-timezone';
import { store } from './store/store';
import { changeLanguage } from './components/Sidebar/actions';

const updateLanguage = (lang) => {
  lang = !lang || lang.indexOf('-') < 0 ? lang : lang.split('-')[0];

  moment.locale(lang);
  console.log(`languageChanged ${lang}`);
  store.dispatch(changeLanguage({ lang }));
}

const onInitialized = () => {
  updateLanguage(i18n.language);
  i18n.on('languageChanged', lang => {
    updateLanguage(lang);
  });
}

i18n
  .use(XHR)
  .use(LanguageDetector)
  .init({
    ns: ['common'],
    defaultNS: 'common',

    debug: true,
    returnObjects: true,

    load: 'languageOnly',
    fallbackLng: 'ru',
    whitelist: ['en', 'ru', 'fr', 'de', 'pt'],
    nonExplicitWhitelist: true,

    interpolation: {
      escapeValue: false, // not needed for react!!
      formatSeparator: ',',
      format(value, format, lng) {
        if (format === 'uppercase') return value.toUpperCase();
        if (format === 'price') {
          if (typeof value !== 'number' || !Number.isFinite(value) || (value % 1)) {
            throw new Error('Price is not integer');
          }
          const valueStr = String(value);
          if (lng === 'ru') {
            return `${valueStr.slice(0, -2).replace(/\B(?=(\d{3})+(?!\d))/g, ' ')},${valueStr.slice(-2)}`;
          }
          return `${valueStr.slice(0, -2)}.${valueStr.slice(-2)}`;
        }
        return value;
      },
    },
  }, onInitialized);

export default i18n;



// WEBPACK FOOTER //
// ./src/i18n.js